import React, { useEffect, useState } from "react";
import { FaDownload, FaSearch } from "react-icons/fa";
import VisibilityToggleBoletin from "../VisibilityToggleBoletin";
import Pagination from "../Pagination";
import DropDown from "../DropDown";
import { useNavigate } from "react-router-dom";

const BoletinAdminView = ({ boletines }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [selectedGrado, setSelectedGrado] = useState("");
  const [filteredBoletines, setFilteredBoletines] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const boletinesPorPagina = 20;

  useEffect(() => {
    const normalize = (str) =>
      str
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    const filtered = boletines.filter((b) => {
      const matchesName =
        searchValue === "" ||
        normalize(b.nombre_estudiante).includes(normalize(searchValue));

      const matchesGrado =
        selectedGrado === "" || normalize(b.grado) === normalize(selectedGrado);

      return matchesGrado && matchesName;
    });

    setFilteredBoletines(filtered);
    setCurrentPage(1);
  }, [searchValue, selectedGrado, boletines]);

  const paginatedBoletines = filteredBoletines.slice(
    (currentPage - 1) * boletinesPorPagina,
    currentPage * boletinesPorPagina
  );

  const totalPaginas = Math.ceil(filteredBoletines.length / boletinesPorPagina);

  const handleDownloadPDF = async (pdfUrl) => {
    try {
      const fileResponse = await fetch(pdfUrl);
      const blob = await fileResponse.blob();
      const url = window.URL.createObjectURL(blob);
      const decodedUrl = decodeURIComponent(pdfUrl);
      const parts = decodedUrl.split("/");
      let rawFilename = parts[parts.length - 1];
      if (!rawFilename.endsWith(".pdf")) rawFilename += ".pdf";

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", rawFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    }
  };

  return (
    <>
      <div className="bg-white p-6 rounded-2xl shadow-md">
        <h3 className="text-xl font-semibold mb-4">Boletines de Estudiantes</h3>

        <div className="flex flex-col md:flex-row gap-3 mb-6">
          <div className="w-full md:w-1/3 relative">
            <FaSearch className="absolute left-4 top-5 transform -translate-y-1/2" />
            <input
              type="text"
              placeholder="Buscar por nombre..."
              className="w-full pl-10 pr-4 py-2 bg-gray-100 border rounded-full outline-none"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>

          <div className="w-full md:w-1/3">
            <DropDown
              value={selectedGrado}
              onChange={(e) => setSelectedGrado(e.target.value)}
              placeholder="Todos los grados"
              options={[
                { value: "", label: "Todos los grados" },
                ...[...new Set(boletines.map((b) => b.grado))].map((grado) => ({
                  value: grado,
                  label: grado
                }))
              ]}
            />
          </div>

          <div className="flex gap-2">
            <VisibilityToggleBoletin />
            <button
              onClick={() => navigate('/boletin-final')}
              className="px-4 py-2 bg-green text-white rounded-lg text-sm font-semibold hover:bg-green-light transition"
            >
              5º Período
            </button>
          </div>
        </div>

        {filteredBoletines.length === 0 ? (
          <p>No hay boletines registrados para los filtros seleccionados.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="table-fixed w-full border-collapse border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border px-4 py-2 w-[30%]">Estudiante</th>
                  <th className="border px-4 py-2 w-[20%]">Periodo</th>
                  <th className="border px-4 py-2 w-[15%]">Inasistencias</th>
                  <th className="border px-4 py-2 w-[20%]">Promedio</th>
                  <th className="border px-4 py-2 w-[15%]">Acción</th>
                </tr>
              </thead>
              <tbody>
                {paginatedBoletines.map((boletin) => (
                  <tr key={`${boletin.students_id}-${boletin.periodo_id}`}>
                    <td className="border px-4 py-2 text-center w-[30%]">
                      {boletin.nombre_estudiante}
                    </td>
                    <td className="border px-4 py-2 text-center w-[20%]">
                      {boletin.periodo_nombre}
                    </td>
                    <td className="border px-4 py-2 text-center w-[15%]">
                      {boletin.inasistencias}
                    </td>
                    <td className="border px-4 py-2 text-center w-[20%]">
                      {boletin.promedio_final_periodo?.toFixed(2) || "-"}
                    </td>
                    <td className="border px-4 py-2 text-center w-[15%]">
                      {boletin.pdf_url ? (
                        <button
                          onClick={() => handleDownloadPDF(boletin.pdf_url)}
                          className="text-green hover:text-main-blue"
                          title="Descargar PDF"
                        >
                          <FaDownload size={20} />
                        </button>
                      ) : (
                        <FaDownload
                          size={20}
                          className="cursor-not-allowed mx-auto"
                          title="PDF no disponible"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Paginación fuera del contenedor blanco */}
      {totalPaginas > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPaginas}
          onPageChange={setCurrentPage}
        />
      )}
    </>
  );
};

export default BoletinAdminView;